<template>
  <v-flex xs12 mb-4>
    <v-layout row wrap>
	  	<v-flex xs12 sm6 md3 pa-2>
	      <v-card class="elevation-2" color="light-blue">
	        <v-card-title>
	          <v-flex xs6>
	          	<v-icon class="white--text" size="72" style="font-weight:400">fa fa-thermometer-half</v-icon>
	          </v-flex>
	    	  <v-flex xs6 class="text-xs-right">
		        <h3 class="display-2 white--text thin-font">{{setPoint}}</h3>
		        <h6 class="caption white--text text--lighten-1">℃</h6>
	    	  </v-flex>
	        </v-card-title>
	        <v-divider color="white"></v-divider>
	        <v-card-actions>
	          <div class="body-1 white--text text--lighten-1 ">SET POINT</div>
	        </v-card-actions>
	      </v-card>
	    </v-flex>
      <v-flex xs12 sm6 md3 pa-2>
	      <v-card class="elevation-2" color="indigo">
	        <v-card-title>
	          <v-flex xs6>
	          	<v-icon class="white--text" size="72" style="font-weight:400">fa fa-thermometer-quarter</v-icon>
	          </v-flex>
	    	  <v-flex xs6 class="text-xs-right">
		        <h3 class="display-2 white--text thin-font">{{preValue}}</h3>
		        <h6 class="caption white--text text--lighten-1">℃</h6>
	    	  </v-flex>
	        </v-card-title>
	        <v-divider color="white"></v-divider>
	        <v-card-actions>
	          <div class="body-1 white--text text--lighten-1 ">PRESENT VALUE</div>
	        </v-card-actions>
	      </v-card>
	    </v-flex>
      <v-flex xs12 sm6 md3 pa-2>
	      <v-card class="elevation-2" color="deep-orange">
	        <v-card-title>
	          <v-flex xs6>
	          	<v-icon class="white--text" size="72">loop</v-icon>
	          </v-flex>
	    	  <v-flex xs6 class="text-xs-right">
		        <h3 class="display-2 white--text thin-font">{{spindleValue}}%</h3>
		        <h6 class="caption white--text text--lighten-1">40.000 min</h6>
	    	  </v-flex>
	        </v-card-title>
	        <v-divider color="white"></v-divider>
	        <v-card-actions>
	          <div class="body-1 white--text text--lighten-1">SPINDLE LOAD</div>
	        </v-card-actions>
	      </v-card>
	    </v-flex>
	    <v-flex xs12 sm6 md3 pa-2>
	      <v-card class="elevation-2" color="amber">
	        <v-card-title>
	          <v-flex xs6>
	          	<v-icon class="white--text" size="72">timeline</v-icon>
	          </v-flex>
	    	  <v-flex xs6 class="text-xs-right">
		        <h3 class="display-2 white--text thin-font">{{feedValue}}</h3>
		        <h6 class="caption white--text text--lighten-1">mm/min</h6>
	    	  </v-flex>
	        </v-card-title>
	        <v-divider color="white"></v-divider>
	        <v-card-actions>
	          <div class="body-1 white--text text--lighten-1">POSITIONING FEED</div>
	        </v-card-actions>
	      </v-card>
	    </v-flex>
    </v-layout>
    <v-layout row wrap py-3>
      <v-flex xs12 sm6 md6 pa-2>
        <v-toolbar color="green" dark>
            <v-icon>fullscreen</v-icon>
            <v-toolbar-title>FEED TREND</v-toolbar-title>
        </v-toolbar>
        <v-card class="white--text subheading">
            <LineChart></LineChart>
        </v-card>
      </v-flex>          
      <v-flex xs12 sm6 md6  pa-2>
        <v-toolbar color="indigo" dark>
            <v-icon>fa-thermometer</v-icon>
            <v-toolbar-title>TEMPERATURE</v-toolbar-title>
        </v-toolbar>          
        <v-card class="white--text subheading ">
            <AreaChart></AreaChart>
        </v-card>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs12 sm6 md6  pa-2>
        <v-toolbar color="warning" dark>
            <v-icon>grain</v-icon>
            <v-toolbar-title>불량원인</v-toolbar-title>
        </v-toolbar>          
        <v-card class="white--text subheading">
            <PieChart></PieChart>
        </v-card>
      </v-flex> 
      <v-flex xs12 sm6 md6 pa-2>
        <v-toolbar color="accent" dark>
            <v-icon>widgets</v-icon>
            <v-toolbar-title>라인별 생산현황</v-toolbar-title>
        </v-toolbar>
        <v-card class="white--text subheading">
            <BarChart></BarChart>
        </v-card>
      </v-flex>          
    </v-layout>
  </v-flex>
</template>
<script>
import LineChart from '@/components/LineChart.vue'
import AreaChart from '@/components/AreaChart.vue'
import BarChart from '@/components/BarChart.vue'
import PieChart from '@/components/PieChart.vue'
  export default {
    name: 'Dashboard',
    components: {
        LineChart,
        AreaChart,
        BarChart,
        PieChart
    },
    data () {
      return {
        feedValue: '',
        preValue: '',
        setPoint: '',
        spindleValue: ''
      }
    },
    created () {
      this.$root.breadcrumbs = [
        {
          text: 'Home',
          disabled: false,
          href: '/'
        },
        {
          text: 'Dashboard',
          disabled: true
        }
      ],
      this.getData ()
    },
    watch: {
    },
    computed:{ 
    },
    beforeDestroy () {
      clearInterval(this.chartDataInterval)
    },
    methods: {
      getData () {
        this.chartDataInterval = setInterval(() => {
          this.axios.get(`mod_getRealtime_random.php`)
            .then((result) => {
                this.feedValue = result.data[0].feedValue
                this.preValue = result.data[0].preValue
                this.setPoint = result.data[0].setPoint
                this.spindleValue = result.data[0].spindleValue
                //console.log(result.data)
            })
          }, 1000)
      }
    }
  }
</script>
<style>
.thin-font {
  font-weight: 100 !important
}
</style>
